module.exports = __webpack_public_path__ + "img/icon_js.12ff1f17.png";